var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scriptLoaded && _vm.dropboxChooserIsSupported)?_c('div',{on:{"click":_vm.openChooser}},[_vm._t("default"),(!this.$slots.default)?_c('button',[_vm._v("Open dropbox picker")]):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }